import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardBuilderComponent } from './card-builder/card-builder.component';
import { CardBuilderSettingsComponent } from './card-builder-settings/card-builder-settings.component';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { RappiderSelectModule } from '../select/select.module';
import { RappiderTextboxModule } from '../textbox/textbox.module';
import { FormsModule } from '@angular/forms';
import { RappiderModalModule } from '../modal/modal.module';
import { RappiderSwitchModule } from '../switch/switch.module';
import { RappiderButtonModule } from '../button/button.module';
import { RappiderStringArrayModule } from '../string-array/string-array.module';
import { AngularSplitModule } from 'angular-split';
import { RappiderJsonEditorModalModule } from '../json-editor-modal/json-editor-modal.module';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { RappiderAlertModule } from '../alert/alert.module';
import { RappiderCardCcsModule } from '../card-ccs/card-ccs.module';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { RappiderRowSelectModule } from '../row-select/row-select.module';
import { RappiderIconPickerWrapperModule } from '../icon-picker-wrapper/icon-picker-wrapper.module';
import { RappiderMonacoEditorModule } from '../monaco-editor/monaco-editor.module';
import { RappiderGridBuilderModule } from '../grid-builder/grid-builder.module';

@NgModule({
  declarations: [
    CardBuilderComponent,
    CardBuilderSettingsComponent
  ],
  imports: [
    CommonModule,
    NzTabsModule,
    FormsModule,
    RappiderModalModule,
    RappiderTextboxModule,
    RappiderSelectModule,
    RappiderSwitchModule,
    RappiderButtonModule,
    RappiderStringArrayModule,
    AngularSplitModule,
    NzToolTipModule,
    RappiderAlertModule,
    RappiderJsonEditorModalModule,
    RappiderCardCcsModule,
    NzEmptyModule,
    RappiderRowSelectModule,
    RappiderIconPickerWrapperModule,
    RappiderMonacoEditorModule,
    RappiderGridBuilderModule
  ],
  exports: [
    CardBuilderComponent
  ]
})
export class RappiderCardBuilderModule { }
